import React from "react"
import { Icon, Label } from "@/components"
import { Group, Stack, Badge } from "@mantine/core"
import { useFormContext } from "react-hook-form"
import classes from "@/pages/campaign-form/components/campaigns/personalizedMessages/components/AI/AIMessageConfiguration.module.css"

interface ConfigurationBadgeProps {
    fieldName: string
    fieldValue: string
    icon: string
    label: string
}

const ConfigurationBadge = ({ fieldName, fieldValue, icon, label }: ConfigurationBadgeProps) => {
    const formContext = useFormContext()
    const isSelected = formContext.watch(fieldName) === fieldValue

    return (
        <Badge
            variant="outline"
            radius="lg"
            size="lg"
            className={isSelected ? classes.badgeSelected : classes.badge}
            leftSection={<Icon iconFamily="fal" icon={icon} />}
            onClick={() => formContext.setValue(fieldName, fieldValue)}
        >
            {label}
        </Badge>
    )
}

const TONE_CONFIGURATIONS = [
    { value: "friendly", icon: "smile-beam", label: "Friendly" },
    { value: "informal", icon: "island-tropical", label: "Informal" },
    { value: "serious", icon: "user-tie", label: "Serious" },
    { value: "urgent", icon: "exclamation-triangle", label: "Urgent" },
] as const

const LENGTH_CONFIGURATIONS = [
    { value: "short", icon: "grip-lines", label: "Short" },
    { value: "medium", icon: "bars", label: "Medium" },
    { value: "long", icon: "align-justify", label: "Long" },
] as const

export const AIMessageConfiguration = () => {
    return (
        <Stack>
            <Stack spacing="xs" align="flex-start">
                <Label className={classes.label} label="Tone" />
                <Group spacing="xs">
                    {TONE_CONFIGURATIONS.map((tone) => (
                        <ConfigurationBadge
                            key={tone.value}
                            fieldName="ai_options.tone"
                            fieldValue={tone.value}
                            icon={tone.icon}
                            label={tone.label}
                        />
                    ))}
                </Group>
            </Stack>
            <Stack spacing="xs" align="flex-start">
                <Label className={classes.label} label="Length" />
                <Group spacing="xs">
                    {LENGTH_CONFIGURATIONS.map((length) => (
                        <ConfigurationBadge
                            key={length.value}
                            fieldName="ai_options.length"
                            fieldValue={length.value}
                            icon={length.icon}
                            label={length.label}
                        />
                    ))}
                </Group>
            </Stack>
        </Stack>
    )
}

export default AIMessageConfiguration
